import React, { useState } from 'react';

import { Field } from 'formik';

import FileDropzone from '../../common/FileDropzone';



const InformationsApicolesADAR = ({ formikProps }) => {

  const { errors, touched, setFieldValue, values } = formikProps;

  const [uploading, setUploading] = useState({});

  const [fileErrors, setFileErrors] = useState({});

  // === Section Documents ===

  const getAllRequiredDocuments = () => {

    const nombreRuches = values.informationsApicoles?.nombreRuches || 0;

    const typePersonne = values.informationsPersonnelles?.typePersonne || '';

    const documents = [

      { id: 'declaration_ruches', label: 'Déclaration de ruches (campagne de déclaration de septembre à décembre N-1)', required: true, category: 'ADAR' }

    ];

    

    // Ajouter le relevé CGSS si plus de 60 ruches ET si ce n'est pas une association ou établissement public

    const isExemptFromCGSS = typePersonne === 'association' || typePersonne === 'etablissement_public';

    if (nombreRuches >= 60 && !isExemptFromCGSS) {

      documents.push({

        id: 'releve_exploitation_cgss',

        label: `Relevé d'exploitation émis par la CGSS de La Réunion (année ${values.annee || new Date().getFullYear()})`,

        required: true,

        category: 'ADAR'

      });

    }

    

    return documents;

  };



  const hasExistingFile = (category, docId) => {

    const fieldName = `documents${category}`;

    const documents = values[fieldName] || [];

    return documents.some(doc => doc.type === docId);

  };



  const getExistingFile = (category, docId) => {

    const fieldName = `documents${category}`;

    const documents = values[fieldName] || [];

    return documents.find(doc => doc.type === docId);

  };



  const handleFileRemove = (category, docId) => {

    const fieldName = `documents${category}`;

    const documents = values[fieldName] || [];

    const updatedDocuments = documents.filter(doc => doc.type !== docId);

    setFieldValue(fieldName, updatedDocuments);

  };



  const handleFileUpload = async (file, documentType, category) => {

    if (!file) return;



    try {

      setUploading(prev => ({ ...prev, [documentType]: true }));

      setFileErrors(prev => ({ ...prev, [documentType]: null }));



      const reader = new FileReader();

      reader.onloadend = () => {

        const base64String = reader.result;

        const fieldName = `documents${category}`;

        const currentDocuments = values[fieldName] || [];

        const updatedDocuments = currentDocuments.filter(doc => doc.type !== documentType);

        

        updatedDocuments.push({

          nom: file.name.replace(/\.[^/.]+$/, ''),

          nomOriginal: file.name,

          type: documentType,

          organisme: category,

          mimeType: file.type,

          taille: file.size,

          base64Data: base64String,

          isTemporary: true

        });



        setFieldValue(fieldName, updatedDocuments);

        setUploading(prev => ({ ...prev, [documentType]: false }));

      };



      reader.onerror = () => {

        setFileErrors(prev => ({ ...prev, [documentType]: 'Erreur lors de la lecture du fichier' }));

        setUploading(prev => ({ ...prev, [documentType]: false }));

      };



      reader.readAsDataURL(file);

    } catch (error) {

      console.error('Erreur lors de l\'upload:', error);

      setFileErrors(prev => ({ ...prev, [documentType]: 'Erreur lors de l\'upload du fichier' }));

      setUploading(prev => ({ ...prev, [documentType]: false }));

    }

  };



  return (

    <div className="space-y-8">

      <div className="text-center">

        <h3 className="text-lg font-medium leading-6 text-gray-900">

          Informations apicoles

        </h3>

        <p className="mt-1 text-sm text-gray-500">

          Veuillez renseigner vos informations apicoles

        </p>

      </div>



      <div className="bg-white shadow-sm rounded-lg p-6 space-y-6">

        {/* Nombre de ruches et ruchers */}

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">

          <div>

            <label htmlFor="nombreRuches" className="block text-sm font-medium text-gray-700">

              Nombre de ruches <span className="text-red-500">*</span>

            </label>

            <div className="mt-1">

              <Field

                type="number"

                id="nombreRuches"

                name="informationsApicoles.nombreRuches"

                min="0"

                className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md p-2"

              />

              {errors.informationsApicoles?.nombreRuches && touched.informationsApicoles?.nombreRuches && (

                <p className="mt-2 text-sm text-red-600">{errors.informationsApicoles.nombreRuches}</p>

              )}

            </div>

          </div>



          <div>

            <label htmlFor="nombreRuchers" className="block text-sm font-medium text-gray-700">

              Nombre d'emplacements <span className="text-red-500">*</span>

            </label>

            <div className="mt-1">

              <Field

                type="number"

                id="nombreRuchers"

                name="informationsApicoles.nombreRuchers"

                min="0"

                className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md p-2"

              />

              {errors.informationsApicoles?.nombreRuchers && touched.informationsApicoles?.nombreRuchers && (

                <p className="mt-2 text-sm text-red-600">{errors.informationsApicoles.nombreRuchers}</p>

              )}

            </div>

          </div>

        </div>



        {/* Localisation */}

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">

          <div>

            <label htmlFor="departement" className="block text-sm font-medium text-gray-700">

              Département <span className="text-red-500">*</span>

            </label>

            <div className="mt-1">

              <Field

                type="text"

                id="departement"

                name="informationsApicoles.localisation.departement"

                placeholder="Ex: 974"

                className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md p-2"

              />

              {errors.informationsApicoles?.localisation?.departement && touched.informationsApicoles?.localisation?.departement && (

                <p className="mt-2 text-sm text-red-600">{errors.informationsApicoles.localisation.departement}</p>

              )}

            </div>

          </div>



          <div>

            <label htmlFor="commune" className="block text-sm font-medium text-gray-700">

              Commune <span className="text-red-500">*</span>

            </label>

            <div className="mt-1">

              <Field

                type="text"

                id="commune"

                name="informationsApicoles.localisation.commune"

                placeholder="Ex: Saint-Denis"

                className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md p-2"

              />

              {errors.informationsApicoles?.localisation?.commune && touched.informationsApicoles?.localisation?.commune && (

                <p className="mt-2 text-sm text-red-600">{errors.informationsApicoles.localisation.commune}</p>

              )}

            </div>

          </div>

        </div>



        {/* NAPI - OBLIGATOIRE pour ADAR */}

        <div>

          <label htmlFor="napi" className="block text-sm font-medium text-gray-700">

            NAPI (Numéro d'Apiculteur) <span className="text-red-500">*</span>

          </label>

          <div className="mt-1">

            <Field

              type="text"

              id="napi"

              name="informationsApicoles.napi"

              placeholder="Ex: 97400001"

              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md p-2"

            />

            {errors.informationsApicoles?.napi && touched.informationsApicoles?.napi && (

              <p className="mt-2 text-sm text-red-600">{errors.informationsApicoles.napi}</p>

            )}

          </div>

        </div>



        {/* Numéro AMEXA */}

        <div>

          <label htmlFor="numeroAmexa" className="block text-sm font-medium text-gray-700">

            Numéro AMEXA {values.informationsApicoles?.nombreRuches > 60 && <span className="text-red-500">*</span>}

          </label>

          <div className="mt-1">

            <Field

              type="text"

              id="numeroAmexa"

              name="informationsApicoles.numeroAmexa"

              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md p-2"

            />

            {errors.informationsApicoles?.numeroAmexa && touched.informationsApicoles?.numeroAmexa && (

              <p className="mt-2 text-sm text-red-600">{errors.informationsApicoles.numeroAmexa}</p>

            )}

            {values.informationsApicoles?.nombreRuches > 60 && (

              <p className="mt-2 text-sm text-gray-500">

                Le numéro AMEXA est obligatoire pour plus de 60 ruches

              </p>

            )}

          </div>

        </div>



        {/* SIRET - OBLIGATOIRE pour ADAR */}

        <div>

          <label htmlFor="siret" className="block text-sm font-medium text-gray-700">

            SIRET <span className="text-red-500">*</span>

          </label>

          <div className="mt-1">

            <Field

              type="text"

              id="siret"

              name="informationsApicoles.siret"
              placeholder="14 chiffres exactement (ex: 12345678901234)"
              maxLength="14"
              onInput={(e) => {
                e.target.value = e.target.value.replace(/\D/g, '');
              }}
              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md p-2"

            />

            {errors.informationsApicoles?.siret && touched.informationsApicoles?.siret && (

              <p className="mt-2 text-sm text-red-600">{errors.informationsApicoles.siret}</p>

            )}

          </div>

        </div>

      </div>

      

      {/* Encart d'information sur la concordance des données */}

      <div className="bg-blue-50 border-l-4 border-blue-400 p-4">

        <div className="flex">

          <div className="flex-shrink-0">

            <svg className="h-5 w-5 text-blue-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">

              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />

            </svg>

          </div>

          <div className="ml-3">

            <p className="text-sm text-blue-700">

              <strong>Important :</strong> L'adhésion à l'ADAR nécessite une concordance des informations de la demande d'adhésion, de la déclaration de ruches et du relevé d'exploitation, notamment du nombre de ruches.

            </p>

            <div className="mt-2 text-sm text-blue-700">

              <p className="font-medium">Liens utiles :</p>

              <ul className="list-disc list-inside mt-1 space-y-1">

                <li>

                  Refaire une déclaration de ruches avec le même nombre de ruches sur{' '}

                  <a 

                    href="https://mesdemarches.agriculture.gouv.fr" 

                    target="_blank" 

                    rel="noopener noreferrer"

                    className="underline hover:text-blue-900 font-medium"

                  >

                    mesdemarches.agriculture.gouv.fr

                  </a>

                </li>

                <li>

                  Récupérer un relevé d'exploitation mis à jour avec le même nombre de ruches sur{' '}

                  <a 

                    href="https://reunion.msa.fr/lfp" 

                    target="_blank" 

                    rel="noopener noreferrer"

                    className="underline hover:text-blue-900 font-medium"

                  >

                    reunion.msa.fr/lfp

                  </a>

                  {' '}(espace privé)

                </li>

              </ul>

            </div>

          </div>

        </div>

      </div>



      {/* Section Documents */}

      <div className="bg-white shadow-sm rounded-lg p-6">

        <h4 className="text-base font-medium text-gray-900 mb-4">Documents requis</h4>

        <div className="space-y-4">

          {getAllRequiredDocuments().map(doc => {

            const hasFile = hasExistingFile(doc.category, doc.id);

            const existingFile = getExistingFile(doc.category, doc.id);

            const isUploading = uploading[doc.id];

            const error = fileErrors[doc.id];



            return (

              <div key={doc.id} className="border border-gray-200 rounded-lg p-4">

                <div className="flex items-start justify-between mb-2">

                  <div className="flex-1">

                    <label className="block text-sm font-medium text-gray-700">

                      {doc.label}

                      {doc.required && <span className="text-red-500 ml-1">*</span>}

                    </label>

                  </div>

                </div>



                {!hasFile ? (

                  <FileDropzone

                    onFileSelect={(file) => handleFileUpload(file, doc.id, doc.category)}

                    accept=".pdf,.jpg,.jpeg,.png"

                    maxSize={5 * 1024 * 1024}

                    isUploading={isUploading}

                  />

                ) : (

                  <div className="flex items-center justify-between bg-green-50 border border-green-200 rounded-md p-3">

                    <div className="flex items-center">

                      <svg className="h-5 w-5 text-green-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">

                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />

                      </svg>

                      <span className="text-sm text-gray-700">{existingFile.nomOriginal}</span>

                    </div>

                    <button

                      type="button"

                      onClick={() => handleFileRemove(doc.category, doc.id)}

                      className="text-red-600 hover:text-red-800 text-sm font-medium"

                    >

                      Supprimer

                    </button>

                  </div>

                )}



                {error && (

                  <p className="mt-2 text-sm text-red-600">{error}</p>

                )}

              </div>

            );

          })}

        </div>

      </div>

    </div>

  );

};



export default InformationsApicolesADAR;

